<template>
  <div id="lm-table-custom">
    <div v-if="!hideSearchSection" class="row mb-3">
      <div class="app-search d-xl-block col-md-7">
        <div
          v-if="isVisibleMoreOptions"
          class="app-search__more-options-content p-3"
          @keydown.esc="closeMoreOptions"
          ref="moreOptionsContent"
          tabindex="-1"
          >
          <div class="row ml-2">
            <div class="col-12 pl-0">
              <h6>{{$t('search_in')}}</h6>
            </div>
          </div>
          <div class="row ml-2" v-if="searchOnFields.length">
            <div
              class="custom-control custom-checkbox col-md-6 mt-1"
              v-for="(option, index) in searchOnFields" :key="index">
              <div v-if="option && option.hasOwnProperty('name')">
                <input
                  class="custom-control-input" type="checkbox"
                  :value="option.name"
                  :id="option.name"
                  v-model="apiCall.searchOnFields">
                <label
                  class="custom-control-label"
                  :for="option.name">
                    {{ keyReadableForHuman(option.humanName) }}
                </label>
              </div>
              <div v-else>
                <input
                  class="custom-control-input" type="checkbox"
                  :value="option"
                  :id="option"
                  v-model="apiCall.searchOnFields">
                <label
                  class="custom-control-label"
                  :for="option">
                    {{ keyReadableForHuman(option) }}
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-3" v-if="showFilterTime" >
            <div class="col-12 col-lg-6 mt-2">
              <LmDate
                v-model="dateTime.from"
                :placeholder="$t('select_date')"
                :label="$t('min_date')"
                :config="lmDateConfigFrom"
                id="dateTimeFrom"
                />
            </div>
            <div class="col-12 col-lg-6 mt-2">
              <LmDate
                v-model="dateTime.upTo"
                :placeholder="$t('select_date')"
                :label="$t('max_date')"
                :config="lmDateConfigUpTo"
                id="dateTimeUpTo"
                />
            </div>
          </div>
          <div class="row ml-2">
            <div class="col-5 mt-4 pl-0">
              <button
                @click="cleanOptions"
                v-if="searchOnFields.length && apiCall.searchOnFields.length >= 1"
                type="button"
                class="btn btn-link btn-sm pl-0"
                >{{ $t('clean_options')}}</button>
              <button
                @click="selectAllOptions"
                v-if="searchOnFields.length && apiCall.searchOnFields.length === 0"
                type="button"
                class="btn btn-link btn-sm pl-0"
                >{{ $t('select_all')}}</button>
            </div>
            <div class="col-7 d-flex justify-content-end mt-4">
              <button @click="closeMoreOptions" type="button" class="btn btn-link btn-sm mr-2">{{$t('close')}}</button>
              <span :id="isSearchButtonDisabled ? 'tooltip-target-1' : ''" class="d-inline-block" tabindex="0">
                <button
                  @click="searchItems"
                  type="button"
                  class="btn btn-primary btn-sm"
                  :disabled="isSearchButtonDisabled"
                  >{{$t('search')}}</button>
                </span>
                <b-tooltip target="tooltip-target-1" triggers="hover">
                  Recuerde seleccionar al menos un criterio de búsqueda
                </b-tooltip>
            </div>

          </div>
        </div>
        <div
          class="input-group"
          @keydown.esc="closeMoreOptions"
          >
          <input
            autofocus
            type="text"
            v-model.trim="apiCall.term"
            class="form-control app-search__main-input"
            @keyup.delete.exact="inputClean"
            @keyup.ctrl.88="inputClean"
            @keyup.enter.exact="searchItems"
            :placeholder="$t('search_placeholder')">
          <span class="mdi mdi-magnify"></span>
          <div class="input-group-append position-relative">
            <button
              v-if="showMoreOptions"
              class="btn btn-primary"
              type="button"
              @click="moreOptions">{{$t('more_options')}}</button>
            <button
              v-if="!showMoreOptions"
              class="btn btn-primary"
              type="button"
              @click="searchItems">{{$t('search')}}</button>
            <i class="noti-icon-badge" v-if="areDefaultFiltersChanged"/>
          </div>
        </div>
      </div>
      <div class="col-md-5 mt-3 mt-sm-0 col-12 d-flex justify-content-md-end" v-if="showLmDropdownTableCustom">
        <LmDropdownTableCustom
          v-if="tableItems.length"
          :options="orderBySetting"
          :optionSelected="$route.query.orderBy"
          :aggregates="aggregates"
          :total-result="tableItemsTotal"
          :selectedAgregates = apiCall.aggregates
          :showMoreAggregatesItemsAt="apiCall.showMoreAggregatesItemsAt"
          :loading = loading
          @dropdownChange="apiCall.orderBy=$event"
          @orderAscDescChanged="apiCall.order=$event"
          @filteredByAggregate="pushAgregates($event)"
          @unSelectedAggregate="spliceAgregates($event)"
          @cleanAllSelectedAgregates="cleanAllSelectedAgregates"
          />
      </div>
    </div> <!-- Row -->
    <div class="table-responsive">
      <div class="table-wrapper">
        <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="top" />
        <table class="table table-striped">
          <thead ref="myThead">
            <tr v-if="tableItems.length">
              <th scope="col" v-for="(el, index) in tableHeader" :key="index">
                <div class="th-wrapper">
                  <span v-if="el === 'lmActions'" class="lm-actions">
                    {{ $t('actions') }}
                  </span>
                  <span v-else-if="el === 'lmFile'" class="lm-image">
                    {{ $t('file') }}
                  </span>
                  <span v-else-if="el === 'lmImage'" class="lm-file">
                    {{ $t('image') }}
                  </span>
                  <span v-else-if="el === 'lmChecked'" class="lm-checked">
                    <input
                      type="checkbox"
                      v-model="lmCheckedAllSelectedStatus"
                      @change="$emit('lmCheckedAllSelectedChange', lmCheckedAllSelectedStatus), lmCheckedAllSelectedChange(lmCheckedAllSelectedStatus)" />
                  </span>
                  <span v-else-if="el === 'lmProgress'" class="lm-progress">
                    {{ tableItems[0].lmProgress.humanName ? tableItems[0].lmProgress.humanName : $t('progress') }}
                  </span>
                  <span v-else-if="el === 'lmBadges'" class="lm-badges">
                    {{ tableItems[0].lmBadges.humanName ? tableItems[0].lmBadges.humanName : $t('tags') }}
                  </span>
                  <span v-else>
                    {{ keyReadableForHuman(el) }}
                  </span>
                  <div class="wrapper-icons" v-if="isOrderly(el)">
                    <font-awesome-icon
                      :class="{ active: activeSortTableHeader(el, 'asc')}"
                      @click="orderByIcon(el, 'asc')"
                      icon="sort-up"
                    />
                    <font-awesome-icon
                      :class="{ active: activeSortTableHeader(el, 'desc')}"
                      @click="orderByIcon(el, 'desc')"
                      icon="sort-down"
                    />
                  </div>
                </div>
              </th>
              <th v-if="actions.length">
                <span>{{$t('actions')}}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!tableItems.length" class="no-search-found-tr">
              <div class="no-search-found">
                <img src="@/assets/images/lumile-logo-no-search.png" alt="lumile-logo" />
                <h1>No se encontraron resultados</h1>
                <h2>Intenta ajustar tu busqueda o filtro para encontrar lo que estás buscando</h2>
              </div>
            </tr>
            <tr v-for="(tr, indexTableItems) in tableItems" :key="indexTableItems">
              <td
                v-for="(objContent, key, index) in removeHiddenColumns(tr)"
                :key="index"
                :style="highlightColummnStyles(objContent, key)"
                >
                <span v-if="key === 'url'" class="font-13 mb-1 font-weight-normal url"><a :href="objContent" target="_blank">{{ objContent }}</a></span>
                <span v-else-if="key === 'lmFile'" class="lm-file">
                  <router-link v-if="objContent.type === 'internal-link'"
                    :to="objContent.url"
                    :title="objContent.title">
                    <font-awesome-icon
                      :icon="objContent.icon"
                      size="lg"
                      class="clickable"
                      />
                  </router-link>
                  <button v-else @click="fillFileModalData(tr)" v-b-modal.fileModal  class="button-action">
                    <font-awesome-icon :icon="objContent.icon" size="lg"/>
                  </button>
                </span>
                <span v-else-if="key === 'lmImage'" class="lm-image">
                  <img v-if="objContent.url" :src="objContent.url" :alt="objContent.name" class="mw-100">
                </span>
                <span v-else-if="key === 'lmChecked'" class="lm-checked">
                  <!-- @input="updateTableItems(tableItems[indexTableItems], indexTableItems, key)" -->
                  <input v-if="tableItems[indexTableItems][key] !== 'disabled'"
                    :checked="lmCheckedAllSelectedStatus ? lmCheckedAllSelectedStatus : tableItems[indexTableItems].lmChecked"
                    @input="updateTableItems($event, tableItems, indexTableItems, key)"
                    type="checkbox"
                    />
                  <input v-else
                    type="checkbox"
                    disabled
                    />
                </span>
                <div v-else-if="key === 'lmActions'" class="lm-actions">
                <template v-for="(option, name, index) in objContent">
                  <font-awesome-icon
                    v-if="option.name === 'openDeleteModalV2'"
                    :key="index"
                    id="open-delete-modal"
                    :icon="option.arguments.fontAwesomeIcon || 'trash'"
                    size="lg"
                    class="clickable text-primary mr-2"
                    @click="openDeleteModalV2(option.arguments.id, option.arguments.endPointPath, option.arguments.message, option.arguments.successMessage)"
                    v-b-tooltip.hover.top="option.arguments.tooltip"
                  />
                  <font-awesome-icon
                    :key="index"
                    id="open-custom-modal"
                    v-if="option.name === 'openCustomModal'"
                    :icon="option.arguments.fontAwesomeIcon || 'window-restore'"
                    size="lg"
                    class="clickable text-primary mr-2"
                    @click="openCustomModal(option.arguments)"
                    v-b-tooltip.hover.top="option.arguments.tooltip"
                  />
                  <router-link
                    v-else
                    :key="index"
                    :to="option.path + (tr[option.registryId] ? tr[option.registryId] : '')"
                    :title="option.title"
                    class="p-1 d-inline-block">
                    <font-awesome-layers class="mr-2" v-if="option.showCounterHoverIcon === true">
                       <font-awesome-icon
                        :icon="option.icon"
                        v-b-tooltip.hover.top="option.title ? option.title : option.tooltip"
                        size="lg"
                        />
                        <font-awesome-layers-text
                          class="text-white fa-layers-counter"
                          transform="down-6 right-7 shrink-10" value=""/>
                    </font-awesome-layers>
                    <font-awesome-icon v-else
                      :icon="option.icon"
                      size="lg"
                      class="clickable"
                      v-b-tooltip.hover.top="option.title ? option.title : option.tooltip"
                      />
                  </router-link>
                </template>
                </div>
                <b-progress class="mt-1" v-else-if="key === 'lmProgress'" :max="100">
                  <b-progress-bar :value="objContent.value" :variant="objContent.variant" />
                </b-progress>
                <div v-else-if="key ==='lmBadges'">
                  <b-badge pill :variant="objContent.variant" v-for="(tag, i) in objContent.value.split(',')" :key="i">{{ tag }}</b-badge>
                </div>
                <router-link v-else-if="objContent && objContent.hasOwnProperty('type') && objContent.type === 'lmUrl'"
                  :to="objContent.url"
                  :title="objContent.name"
                  class="p-1 d-inline-block"
                  >
                  <span class="font-13 mb-1 font-weight-normal dos" :inner-html.prop="objContent.name | lmHighlight(apiCall.term)"></span>
                </router-link>
                <a v-else-if="objContent && objContent.hasOwnProperty('type') && objContent.type === 'url'"
                  :href="objContent.url"
                  :title="objContent.name"
                  class="p-1 d-block text-truncate"
                  replace
                  >
                  <span class="font-13 mb-1 font-weight-normal text-truncate d-block" :inner-html.prop="objContent.name | lmHighlight(apiCall.term)"></span>
                </a>
                <span v-else class="font-13 mb-1 font-weight-normal tres" :inner-html.prop="objContent | lmHighlight(apiCall.term)"></span>
              </td>
              <td class="align-middle" v-if="actions.length">
                <div v-if="!tr.hidden_lmHideActionToolBar">
                  <router-link
                    :to="actionsObj.edit.path + tr[actionsObj.edit.registryId]"
                    v-if="actions.some(e => e.name === 'edit')"
                    :title="actionsObj.edit.title"
                    class="p-1 d-inline-block">
                    <font-awesome-icon
                      icon="edit"
                      size="lg"
                      class="clickable"
                      />
                  </router-link>
                  <input
                    v-if="actionsObj.lmCheck"
                    type="checkbox"
                    checked=checked
                    @change="$emit('change', {checked: $event.target.checked, index})" />
                  <router-link
                    v-for="(option, name, index) in actionsObj.custom" :key="index"
                    :to="option.path + tr[option.registryId]"
                    class="p-1 d-inline-block">
                    <font-awesome-icon
                      :icon="option.icon"
                      size="lg"
                      class="clickable"
                      v-b-tooltip.hover.top="option.title ? option.title : option.tooltip"
                      />
                  </router-link>
                  <div class="p-1 d-inline-block" v-if="actions.some(e => e.name === 'openModal')">
                    <font-awesome-icon
                      icon="search"
                      size="lg"
                      class="clickable"
                      :style="{ color: '#007bff' }"
                      @click="openEmailPreviewModal(tr.hidden_id)"
                    />
                  </div>
                  <div class="p-1 d-inline-block" v-if="actions.some(e => e.name === 'openModalDelete')">
                    <font-awesome-icon
                      icon="trash"
                      size="lg"
                      class="clickable"
                      :style="{ color: '#007bff' }"
                      @click="openDeleteModal(tr.hidden_id, actions[actions.findIndex(e => e.name === 'openModalDelete')].endPointPath)"
                    />
                  </div>
                  <div class="p-1 d-inline-block" v-if="actions.some(e => e.name === 'delete')">
                    <font-awesome-icon
                      icon="trash-alt"
                      size="lg"
                      class="clickable"
                      v-b-modal.deleteModal
                      @click="getSelectedRegistry(tr)"
                      />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row pagination-section">
      <div v-if="tableItems.length" class="showed-items col-md-2 mt-3 align-self-center">
        <p>{{ apiCall.offset + 1 }} {{$t('to')}} {{ apiCall.offset  + tableItems.length }} {{$t('of')}} {{tableItemsTotal}} </p>
      </div>
      <div class="col-md-7 mt-sm-3">
        <LmPagination
          v-if="tableItemsTotal > itemsPerPage "
          :allRegistries="tableItemsTotal"
          :maxAmountItemsShowsPerPaginationInTable="apiCall.limit"
          @paginationNumberClick="urlQueryBuilder({ page: $event })"
          :maxAmountNumbersToShowInPagination="6"
          />
      </div>
      <div class="input-group col-md-3 mt-3 align-self-start" v-if="false">
        <div class="input-group-prepend">
          <label class="input-group-text" for="inputGroupSelect01"> {{$t('per_page')}} </label>
        </div>
        <select v-model.number="itemsPerPage" class="custom-select" id="inputGroupSelect01">
          <option v-for="(el, i) in perPageSetting" :key="i">{{ el }}</option>
        </select>
      </div>
    </div>
    <b-modal
      id="deleteModal"
      ref="deleteModal"
      title="Eliminar registro"
      title-tag="h3"
      :cancel-title="$t('No')"
      :ok-title="$t('Yes')"
      centered
      lazy
      size="90-percent"
      @ok="ok"
      >
      <p>
        {{$t('delete_register_confirmation')}}
      </p>
      <div class="table-responsive">
        <div class="table-wrapper">
          <table class="table table-striped">
            <thead ref="myThead">
              <tr>
                <th scope="col" v-for="(el, index) in tableHeader" :key="index">
                  <div class="th-wrapper">
                    <span>
                      {{ keyReadableForHuman(el) }}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  v-for="(objContent, key, index) in registrySelected"
                  :key="index"
                  :style="highlightColummnStyles(objContent, key)"
                  >
                  <span class="font-13 mb-1 font-weight-normal uno">{{ objContent }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="fileModal"
      hide-footer
      :title="fileModalData.fileDescription"
      title-tag="h5"
      centered
      lazy
      size="90-percent"
      @ok="ok"
      >
      <iframe :src="fileModalData.url" height="100%" width="100%"></iframe>
    </b-modal>
    <LmModalError :message="lmModalError.message"/>
    <LmTemplatePreviewModal ref="lmTemplatePreviewModal" />
    <LmCreateSegmentModal
      ref="lmCreateSegmentModal"
      :fullFrontEndUrl="fullFrontEndUrl"
      :apiEndpoint="apiParams"
      :hash="hash"
      />
    <lmConfirmationModal
      ref="lmConfirmationModal"
      title="Aviso"
      @ok="confirmModalOk"
      />
    <LmButton
      v-if="showGoBackButton"
      type="button"
      @click.native="goBack()"
      buttonClass="btn-secondary"
      :isProcessing="loading"
      :value="$t('go_back')"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
      />
    <span v-if="customLmListActions.length">
      <span v-for="(option, index) in customLmListActions" :key="index">
        <LmButton
          type="button"
          @click.native="clickActionButton(option)"
          :value="$t(option.buttonLabel)"
          button-class="btn-primary"
          :isProcessing="loading"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
      </span>
    </span>
    <span v-else>
      <span v-for="(option, index) in lmListActions" :key="index">
        <LmButton
          type="button"
          @click.native="clickActionButton(option)"
          :value="$t(option.buttonLabel)"
          button-class="btn-danger"
          lmButtonRootWrapperClass="d-inline-block mr-1"
          lmButtonWrapperClass="col"
          />
      </span>
    </span>
    <LmButton
      v-if="tableItems.length && showCSVButton"
      type="button"
      :tooltip="{value:$t('can_not_export_csv'), showOnlyOnDisabled: true}"
      :disabled="tableItemsTotal > exportCsvData.limitExportFromClient"
      @click.native="exportCsv(tableItemsTotal)"
      :value="$t('csv_export')"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
      :isProcessing="exportCsvData.isLoading"
      />
    <LmButton
      v-if="tableItems.length && showPDFButton"
      type="button"
      @click.native="exportPdf()"
      :value="$t('pdf_export')"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
      :isProcessing="exportCsvData.isLoading"
      />
    <LmButton
      v-if="createSegment.isEnable"
      type="button"
      @click.native="createSegmentMethod"
      :value="$t('segment_creation')"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
      buttonClass="btn-danger"
      :isProcessing="createSegment.isProcessing"
      />
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>En unos minutos recibirá el CSV por correo ...</p>
      <b-progress
        variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      ></b-progress>
    </b-alert>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import JsPDF from 'jspdf'
import 'jspdf-autotable'
import LmPagination from '@/components/LmPagination'
import LmButton from '@/components/form/elements/LmButton'
import LmModalError from '@/components/modals/LmModalError'
import LmDate from '@/components/form/elements/LmDate'
import LmDropdownTableCustom from '@/components/LmDropdownTableCustom.vue'
import LmTemplatePreviewModal from '@/components/modals/LmTemplatePreviewModal.vue'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal.vue'
import LmCreateSegmentModal from '@/components/modals/LmCreateSegmentModal.vue'
import lmToasts from '@/mixins/lmToasts.js'

import { mapState, mapActions } from 'vuex'

import Papa from 'papaparse'
import keyReadableForHuman from '@/helpers/key-readable-for-humans.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import urlQueryBuilder from '@/mixins/urlQueryBuilder.js'
import store from '@/store'
import commonsApi from '@/api/commons'
library.add(fas)

export default {
  components: {
    LmPagination,
    LmButton,
    LmModalError,
    LmDate,
    LmDropdownTableCustom,
    LmTemplatePreviewModal,
    LmCreateSegmentModal,
    lmConfirmationModal
  },
  mixins: [urlQueryBuilder, lmToasts],
  data () {
    return {
      fullFrontEndUrl: '',
      fileModalData: {
        url: '',
        fileDescription: ''
      },
      isVisibleMoreOptions: false,
      dateTime: {
        from: this.$route.query.dateTimeFrom ? this.$route.query.dateTimeFrom : null,
        upTo: this.$route.query.dateTimeUpTo ? this.$route.query.dateTimeUpTo : null
      },
      actionsObj: {
        edit: this.actions.find(element => element.name === 'edit'),
        lmCheck: this.actions.find(element => element.name === 'lmCheck'),
        custom: this.actions.filter(element => element.name === 'custom'),
        openModal: this.actions.filter(element => element.name === 'openModal'),
        openModalDelete: this.actions.filter(element => element.name === 'openModalDelete')
      },
      lmModalError: {
        message: ''
      },
      registrySelected: {},
      valueSelectPaginationMobile: 1,
      search: '',
      top: 0,
      exportCsvData: {
        limitExportFromClient: this.limitExportFromClient,
        isLoading: false
      },
      apiCall: this.setApiCall(),
      dismissSecs: 10,
      dismissCountDown: 0,
      lmCheckedAllSelectedStatus: false
    }
  },
  props: {
    showLmDropdownTableCustom: {
      type: Boolean,
      default: true
    },
    createSegment: {
      type: Object,
      default: () => ({
        isEnable: false,
        isProcessing: false
      })
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    perPageSetting: {
      type: Array,
      default: function () {
        return [5, 10, 15, 20]
      }
    },
    limitExportFromClient: Number,
    order: {
      type: Array,
      required: true
    },
    orderBySetting: {
      type: Array,
      required: true
    },
    searchOnFields: {
      // Puede ser un array de nombres de campos
      // o un array de objetos con la estructura
      // {
      //    name: Real field name
      //    humanName: Readable | Human field name
      // }
      type: Array,
      default: function () {
        return []
      }
    },
    apiCallPath: {
      type: String,
      required: true
    },
    highlight: {
      type: Object,
      default: function () {
        return {
          column: null,
          background: '#fa5c7c',
          fontColor: 'white'
        }
      }
    },
    actions: {
      type: Array,
      default: function () {
        return []
      }
    },
    hideSearchSection: {
      type: Boolean,
      default: true
    },
    showFilterTime: {
      type: Boolean,
      default: false
    },
    downloadCsvFileName: {
      type: String,
      default: 'download'
    },
    showCSVButton: {
      type: Boolean,
      default: true
    },
    showPDFButton: {
      type: Boolean,
      default: false
    },
    lmListActions: {
      type: Array,
      default: () => []
    },
    showGoBackButton: {
      type: Boolean,
      default: false
    },
    // La idea es poder precargar filtros de busqueda y usarlos para inicializar
    // LmTableCustom al momento de cargarse
    enablePreloadFiltering: {
      type: Boolean,
      default: false
    },
    preloadFilterArguments: {
      type: Object,
      default: () => {
        return {
          dateFrom: null,
          dateUpTo: null
        }
      }
    }
  },
  computed: {
    ...mapState('commons', ['tableItems', 'csvItems', 'tableItemsTotal', 'loading', 'aggregates', 'customListTitle', 'customListSubTitle', 'pdfTitle', 'pdfSubtitles', 'customLmListActions', 'apiParams', 'hash']),
    isSearchButtonDisabled () {
      if (this.apiCall.term && this.apiCall.searchOnFields.length) {
        return false
      } else if (this.apiCall.dateFrom || this.apiCall.dateUpTo) {
        return false
      } else {
        return true
      }
    },
    showMoreOptions () {
      return this.searchOnFields.length || this.showFilterTime
    },
    lmDateConfigFrom: function () {
      return {
        maxDate: this.dateTime.upTo || this.lmDateConfigUpTo.maxDate
      }
    },
    lmDateConfigUpTo: function () {
      return {
        maxDate: 'today'
      }
    },
    tableHeader: function () {
      const tableHeaderValues = this.tableItems.map(el => {
        let keys = Object.keys(el).filter(keyName => {
          return !keyName.startsWith('hidden_')
        })
        return keys
      })
      return tableHeaderValues[0]
    },
    areDefaultFiltersChanged () {
      return this.apiCall.searchOnFields.length !== this.searchOnFields.length || this.dateTime.from || this.dateTime.upTo
    }
  },
  watch: {
    preloadFilterArguments: {
      handler: function () {
        this.setPreloadFilterArguments()
      },
      deep: true
    },
    '$route.query' () {
      this.apiCall = this.setApiCall()
      this.getTableItems()
    },
    'apiCall.order' () {
      this.urlQueryBuilder({ order: this.apiCall.order })
    },
    'apiCall.orderBy' () {
      this.urlQueryBuilder({ orderBy: this.apiCall.orderBy })
    },
    'dateTime.from': function () {
      this.apiCall.dateFrom = this.dateTime.from
    },
    'dateTime.upTo': function () {
      this.apiCall.dateUpTo = this.dateTime.upTo
    }
  },
  methods: {
    ...mapActions('commons', ['getItems', 'getCsvItems', 'tableItemsChecks']),
    confirmModalOk (form) {
      this.form = form
    },
    lmCheckedAllSelectedChange (status) {
      const tableItems = this.tableItems.map(item => {
        return {
          ...item,
          lmChecked: status
        }
      })
      this.tableItemsChecks(tableItems)
    },
    updateTableItems (event, tableItems, index, key) {
      const tableItemsCopy = _.cloneDeep(this.tableItems)
      tableItemsCopy[index][key] = event.target.checked
      this.tableItemsChecks(tableItemsCopy)
    },
    getFullFrontEndUrl () {
      this.fullFrontEndUrl = window.location.href
    },
    createSegmentMethod () {
      this.getFullFrontEndUrl()
      this.$refs.lmCreateSegmentModal.lmShow()
    },
    openEmailPreviewModal (idEmailTemplate) {
      this.$refs.lmTemplatePreviewModal.openEmailPreviewModal(idEmailTemplate)
    },
    async openCustomModal (args = {}) {
      let {
        id,
        endpoint,
        title,
        message,
        successMessage,
        isComment,
        isCommentValidationRequired,
        labelComment,
        requestMethod,
        delayAfterSubmit
      } = args
      this.$refs.lmConfirmationModal.setMessageProps(message || 'Está seguro que desea realizar esta acción?')
      this.$refs.lmConfirmationModal.setTitleProps(title || 'Aviso')
      this.$refs.lmConfirmationModal.setIsCommentProps(isComment, isCommentValidationRequired, labelComment)
      if (id) this.$refs.lmConfirmationModal.setId(id)
      //   this.$refs.lmConfirmationModal.title = title
      try {
        await this.$refs.lmConfirmationModal.lmShow()
        this.isDataProcessing = true
        // TODO: el tipo de request a realizar debe ser pasado como parametro y los unicos tipos de request
        // permitidos serán POST / PUT / DELETE.  El valor por defecto va a ser POST siempre, incluso si no se
        // especifica
        // Esto es en referencia a lo pedido en https://github.com/lumile/lumbre/issues/729#issuecomment-838668921
        // GET no debe ser utilizado.
        // Y en caso que el modal requiera un comentario el mismo debe enviarse siempre en el request usando como
        // nombre de argumento `comment`
        if (requestMethod === 'POST') {
          await commonsApi.axiosPostWrapper(endpoint, this.form)
        } else if (requestMethod === 'PUT') {
          await commonsApi.axiosPutWrapper(endpoint)
        } else if (requestMethod === 'DELETE') {
          await commonsApi.axiosDeleteWrapper(endpoint)
        } else {
          await commonsApi.axiosPostWrapper(endpoint, this.form)
        }

        // Si hay un delayAfterSubmit mayor a 0 se va a esperar a que finalize el delay para recargar el
        // listado.  Acción que se lleva a cabo indirectamente por la llamada a setDataPageAndComponentsProps()
        if (delayAfterSubmit > 0) {
          setTimeout(() => {
            this.setDataPageAndComponentsProps()
            this.isDataProcessing = false
          }, delayAfterSubmit)
        } else {
          this.setDataPageAndComponentsProps()
          this.isDataProcessing = false
        }
        if (successMessage) {
          this.lmToastSuccessMessage(successMessage, 'Operación realizada con éxito')
        }
      } catch (error) {
        const jsonError = JSON.stringify(error)
        const parseError = JSON.parse(jsonError)
        const errorMessage = parseError.response?.data?.message
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: true
        })
      }
    },
    async openDeleteModal (id, endPointPath) {
      this.$refs.lmConfirmationModal.setMessageProps('Está seguro que desea eliminar este registro?')
      try {
        await this.$refs.lmConfirmationModal.lmShow()
        await axios.delete(
          `${process.env.VUE_APP_API_URL}${endPointPath}${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )
        this.getTableItems()
      } catch (error) {
        const jsonError = JSON.stringify(error)
        const parseError = JSON.parse(jsonError)
        let errorMessage = parseError.response.data.message
        errorMessage = errorMessage === 'update or delete on table "lml_segmentos" violates foreign key constraint "lml_notificacion_segmento_fk" on table "lml_notificaciones"' ? 'No se puede eliminar el segmento porque está vinculado a una notificación.' : errorMessage
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: true
        })
      }
    },
    async openDeleteModalV2 (id, endPointPath, message, successMessage) {
      this.$refs.lmConfirmationModal.setMessageProps(message || 'Está seguro que desea eliminar este registro?')
      try {
        await this.$refs.lmConfirmationModal.lmShow()
        this.isDataProcessing = true
        await commonsApi.axiosDeleteWrapper(process.env.VUE_APP_API_URL + endPointPath + id)
        if (successMessage) {
          this.lmToastSuccessMessage(successMessage, 'Registro Eliminado')
          this.getTableItems()
        }
      } catch (error) {
        const jsonError = JSON.stringify(error)
        const parseError = JSON.parse(jsonError)
        const errorMessage = parseError.response?.data?.message
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isDataProcessing = false
      }
    },
    urlQueryBuilderAgregates () {
      this.urlQueryBuilder({ page: null })
      this.urlQueryBuilder({ aggregates: JSON.stringify(this.apiCall.aggregates) })
    },
    cleanAllSelectedAgregates () {
      this.apiCall.aggregates = []
      this.urlQueryBuilderAgregates()
    },
    pushAgregates (event) {
      this.apiCall.aggregates.push(event)
      this.urlQueryBuilderAgregates()
    },
    spliceAgregates (event) {
      this.apiCall.aggregates.splice(event, 1)
      this.urlQueryBuilderAgregates()
    },
    setApiCall () {
      return {
        path: this.apiCallPath,
        offset: this.$route.query.page ? (this.$route.query.page - 1) * this.itemsPerPage : 0,
        limit: this.itemsPerPage,
        term: this.$route.query.term || null,
        order: this.$route.query.order || this.order[0],
        orderBy: this.$route.query.orderBy || this.orderBySetting[0],
        dateFrom: this.$route.query.dateTimeFrom || null,
        dateUpTo: this.$route.query.dateTimeUpTo || null,
        searchOnFields: (() => {
          if (this.$route.query.searchOnFields) {
            return JSON.parse(this.$route.query.searchOnFields)
          } else {
            return this.searchOnFields.find(i => i.name) ? this.searchOnFields.map(i => i.name) : this.searchOnFields
          }
        }
        )(),
        aggregates: this.$route.query.aggregates ? JSON.parse(this.$route.query.aggregates) : []
      }
    },
    setPreloadFilterArguments () {
      if (this.enablePreloadFiltering) {
        this.apiCall.aggregates.length = 0
        this.apiCall.dateFrom = this.preloadFilterArguments.dateFrom
        this.apiCall.dateUpTo = this.preloadFilterArguments.dateUpTo
        if (this.preloadFilterArguments.idOficinaOrigen) {
          this.apiCall.aggregates.push({
            idOficinaOrigen: this.preloadFilterArguments.idOficinaOrigen
          })
        }
        if (this.preloadFilterArguments.idOficinaDestino) {
          this.apiCall.aggregates.push({
            idOficinaDestino: this.preloadFilterArguments.idOficinaDestino
          })
        }
        this.getTableItems()
      }
    },
    fillFileModalData (data) {
      this.fileModalData.url = data.lmFile.url
      this.fileModalData.fileDescription = data.descripcion ? data.descripcion : ''
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    cleanOptions () {
      this.apiCall.searchOnFields = []
      this.dateTime.from = null
      this.dateTime.upTo = null
      this.$refs.moreOptionsContent.focus()
    },
    focus () {
      this.$refs.moreOptionsContent.focus()
    },
    selectAllOptions () {
      this.apiCall.searchOnFields = this.searchOnFields.find(i => i.name) ? this.searchOnFields.map(i => i.name) : this.searchOnFields
      // this.apiCall.searchOnFields = this.searchOnFields
      this.$refs.moreOptionsContent.focus()
    },
    exportCsv (limit) {
      if (limit > this.exportCsvData.limitExportFromClient) {
        // El export supera el limite y se va a enviar por mail
        let apiCallExport = Object.assign({}, this.apiCall)
        apiCallExport.background = true
        this.getCsvItems(apiCallExport)
          .then(r => {
            this.showAlert()
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        // El export se puede generar como un CSV porque es menor al limite
        const apiCallCsV = Object.assign({}, this.apiCall)
        apiCallCsV.limit = limit
        this.exportCsvData.isLoading = true
        this.getCsvItems(apiCallCsV)
          .then((r) => {
            console.log(this.csvItems)
            const csv = Papa.unparse(this.csvItems)
            const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
            let csvURL = null
            if (navigator.msSaveBlob) {
              csvURL = navigator.msSaveBlob(csvData, `${this.downloadCsvFileName}.csv`)
            } else {
              csvURL = window.URL.createObjectURL(csvData)
            }
            const tempLink = document.createElement('a')
            tempLink.href = csvURL
            tempLink.setAttribute('download', `${this.downloadCsvFileName}.csv`)
            tempLink.click()
          })
          .catch((error) => {
            this.lmModalError.message = error.message
            this.$root.$emit('bv::show::modal', 'errorModal')
          })
          .finally(() => {
            this.exportCsvData.isLoading = false
          })
      }
    },
    ok (bvEvt) {
      bvEvt.preventDefault()
      this.$refs.deleteModal.hide()
    },
    getSelectedRegistry (registry) {
      this.registrySelected = registry
    },
    async getTableItems () {
      // TODO:
      // Si el parametro id esta como argumento en la uri se pasa directo a la API
      // Este funcionamiento por defecto es oscuro y debe mejorarse, ya que cuesta
      // recordar el comportamiento y aunque funciona no esta bueno que al programador
      // le parezca magia y no quede claro como es que realmente todo esta conectado
      if (this.$route.params.id) {
        this.setApiCallId(this.$route.params.id)
      }
      this.$nextTick()
        .then(() => {
          if (this.$refs.myThead) {
            this.top = this.$refs.myThead.clientHeight
          }
        })
      try {
        await this.getItems(this.apiCall)
        const selectedStatus = this.tableItems.every(e => e.lmChecked === true)
        this.lmCheckedAllSelectedStatus = !!selectedStatus
      } finally {
      }
    },
    highlightColummnStyles (objContent, key) {
      if (key === this.highlight.column && objContent === true) {
        return { backgroundColor: this.highlight.background, color: this.highlight.fontColor }
      }
    },
    removeHiddenColumns (row) {
      let rowWithoutHiddenFields = {}
      Object.keys(row).filter((keyName) => {
        // Se quitan las columnas que en su nombre comiencen con hidden_...
        if (!keyName.startsWith('hidden_')) {
          rowWithoutHiddenFields[keyName] = row[keyName]
        }
      })
      return rowWithoutHiddenFields
    },
    isOrderly (el) {
      return this.orderBySetting.includes(el)
    },
    activeSortTableHeader (el, order) {
      return this.apiCall.orderBy === el && this.apiCall.order === order
    },
    orderByIcon (el, order) {
      this.apiCall.orderBy = el
      this.apiCall.order = order
    },
    keyReadableForHuman (key) {
      return keyReadableForHuman(key)
    },
    inputClean () {
      if (!this.apiCall.term) {
        this.urlQueryBuilder({ term: null })
        this.urlQueryBuilder({ page: null })
      }
    },
    searchItems () {
      this.closeMoreOptions()
      this.urlQueryBuilder({ page: null })
      this.urlQueryBuilder({ 'term': this.apiCall.term })
      this.urlQueryBuilder({ searchOnFields: JSON.stringify(this.apiCall.searchOnFields) })
      this.urlQueryBuilder({ dateTimeFrom: this.apiCall.dateFrom })
      this.urlQueryBuilder({ dateTimeUpTo: this.apiCall.dateUpTo })
    },
    moreOptions () {
      this.isVisibleMoreOptions = !this.isVisibleMoreOptions
    },
    closeMoreOptions () {
      this.isVisibleMoreOptions = false
    },
    setApiCallId (id) {
      this.apiCall.id = id
    },
    goBack () {
      this.$router.go(-1)
    },
    exportPdf () {
      let pdfName = `${this.downloadCsvFileName}-${this.apiCall.id}.pdf`
      var doc = new JsPDF()
      if (this.pdfTitle) {
        doc.text(this.pdfTitle, 10, 10)
        doc.line(10, 15, doc.getTextDimensions(this.pdfTitle).w + 10, 15)
      }

      let index = 30
      for (let splitTitle of this.pdfSubtitles) {
        splitTitle = doc.splitTextToSize(splitTitle, 270)
        doc.setFontType('normal')
        doc.setFontSize('10')
        var y = index
        for (var i = 0; i < splitTitle.length; i++) {
          if (y > 280) {
            y = 10
            doc.addPage()
          }
          doc.text(15, y, splitTitle[i])
          y = y + 7
        }
        index += 5
      }

      doc.autoTable({
        theme: 'grid',
        styles: {
          halign: 'center',
          fontSize: 8
        },
        startY: 60,
        html: '.table-striped'
      })
      doc.save(pdfName)
      return false
    },
    clickActionButton (option) {
      if (option.buttonCallPath) {
        if (option.buttonPathArgs) {
          this.$router.push({
            path: `${option.buttonCallPath}/${this.$route.params[option.buttonPathArgs]}`
          })
        } else {
          this.$router.push(option.buttonCallPath)
        }
      }
    }
  },
  created () {
    this.setPreloadFilterArguments()
    if (this.enablePreloadFiltering === false) {
      this.getTableItems()
    }
  }
}
</script>

<style scoped>
  .app-search {
  padding: 0 15px;
  overflow: visible;
}

@media (max-width: 768px) {
  .app-search {
    margin-top: 1.5rem !important;
  }
}

.app-search .icon {
  color: #727bf5;
}

.app-search .noti-icon-badge {
  z-index: 7;
  right: 5px;
  top: 5px;
  left: auto;
}

.app-search input {
  border: 1px solid #ced4da !important;
}

.app-search .app-search__more-options-content {
  position: absolute;
  background: white;
  z-index: 11;
  width: calc(100% - 30px);
  top: 38px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 0 0 0.25rem 0.25rem;
}

select option::first-letter {
  text-transform: uppercase;
  color: red;
}

.table-responsive {
  border: none;
}

@media (max-width: 1200px) {
  .table-responsive {
    border: 1px solid #dee2e6;
  }
}

.table-responsive .table-wrapper {
  min-height: 100px;
  position: relative;
  border: 1px solid #dee2e6;
}

@media (max-width: 1200px) {
  .table-responsive .table-wrapper {
    border: none;
  }
}

.table-responsive table {
  height: 1px;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  max-width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
}

@media (max-width: 1200px) {
  .table-responsive table {
    table-layout: auto;
  }
}

.table-responsive table td {
  height: 100%;
}

.table-responsive table td span.font-13 {
  font-size: 13px;
}

.table-responsive table .button-action {
  border: none;
  background: transparent;
  padding: 0;
  color: var(--primaryThemeColor);
  outline: none;
}

.table-responsive table .button-action:hover,
.table-responsive table .button-action:active,
.table-responsive table .button-action:focus,
.table-responsive table .button-action:visited {
  outline: none;
}

.table-responsive table .button-action svg:active,
.table-responsive table .button-action svg:focus,
.table-responsive table .button-action svg:visited {
  outline: none;
}

.table-responsive thead tr th {
  height: 100%;
  position: sticky;
  background: white;
  top: -1px;
}

.table-responsive thead tr th .th-wrapper {
  display: flex;
  justify-content: space-between;
  height: 100%;
}

.table-responsive thead tr th .th-wrapper span {
  align-self: center;
}

.table-responsive thead tr th .th-wrapper .wrapper-icons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 5px;
}

.table-responsive thead tr th .th-wrapper .wrapper-icons svg {
  cursor: pointer;
  position: relative;
  opacity: 0.5;
}

.table-responsive thead tr th .th-wrapper .wrapper-icons svg.active {
  opacity: 1;
}

.badge {
  font-size: 80%;
}

.no-search-found-tr {
  background-color: rgba(241, 243, 250, 0.6);
}

.no-search-found-tr .no-search-found {
  padding: 5%;
  flex-grow: 1;
}

.no-search-found-tr .no-search-found img {
  margin: 0 auto 30px auto;
  display: block;
}

@media (max-width: 768px) {
  .no-search-found-tr .no-search-found img {
    max-width: 50%;
  }
}

.no-search-found-tr .no-search-found h1,
.no-search-found-tr .no-search-found h2 {
  color: var(--primaryFontThemeColor);
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
}

@media (max-width: 768px) {
  .no-search-found-tr .no-search-found h1,
  .no-search-found-tr .no-search-found h2 {
    min-width: 100px;
  }
}

.no-search-found-tr .no-search-found h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .no-search-found-tr .no-search-found h1 {
    font-size: 18px;
  }
}

.no-search-found-tr .no-search-found h2 {
  font-size: 18px;
}

@media (max-width: 768px) {
  .no-search-found-tr .no-search-found h2 {
    font-size: 14px;
  }
}
</style>
